module.exports = __webpack_public_path__ + "img/partly-cloudy-night.98af7102.svg";